import React from 'react'
import { Redirect } from 'react-router-dom'
import { getOfferingsPath, OFFERINGS_TAB } from '../offerings/routes'

const EventsPage = () => (
  <Redirect to={getOfferingsPath(OFFERINGS_TAB.GROUP_EVENTS)} />
)

export default EventsPage
